import { render, staticRenderFns } from "./page-profile.vue?vue&type=template&id=301a45b4&scoped=true"
import script from "./page-profile.vue?vue&type=script&lang=js"
export * from "./page-profile.vue?vue&type=script&lang=js"
import style0 from "./page-profile.vue?vue&type=style&index=0&id=301a45b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301a45b4",
  null
  
)

export default component.exports